import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=22492acc&"
import script from "./WorkExperience.vue?vue&type=script&lang=ts&"
export * from "./WorkExperience.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports